import { render, staticRenderFns } from "./ResponseDefault.vue?vue&type=template&id=2f8e17e2&scoped=true"
import script from "./ResponseDefault.vue?vue&type=script&lang=js"
export * from "./ResponseDefault.vue?vue&type=script&lang=js"
import style0 from "./ResponseDefault.vue?vue&type=style&index=0&id=2f8e17e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e17e2",
  null
  
)

export default component.exports